import { TFunction } from 'i18next';

export const copyRecord = (t: TFunction) => {
  return {
    description: {
      basic: t('auth:onHold.description.basic'),
      email: t('auth:onHold.description.email'),
      payment: t('auth:onHold.description.payment'),
      pro: t('auth:onHold.description.pro'),
    },
    title: {
      basic: t('auth:onHold.title.basic'),
      pro: t('auth:onHold.title.pro'),
      subscription: t('auth:onHold.title.subscription'),
      trial: t('auth:onHold.title.trial'),
    },
  };
};

export const getTitleType = ({
  reason,
  subscriptionType,
}: {
  reason: string | null;
  subscriptionType: PageVariants;
}) => {
  if (reason === PageVariants.Subscription || reason === PageVariants.Trial) {
    return reason;
  }

  return subscriptionType;
};

export const getDescriptionType = ({
  reason,
  subscriptionType,
}: {
  reason: string | null;
  subscriptionType: PageVariants;
}) => {
  if (reason === PageVariants.Email || reason === PageVariants.Payment) {
    return reason;
  }

  return subscriptionType;
};

export enum PageVariants {
  Basic = 'basic',
  Email = 'email',
  Payment = 'payment',
  Pro = 'pro',
  Subscription = 'subscription',
  Trial = 'trial',
}
